import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        // 以下是与地图相关的
        user: {
            userId: "",
            userName: "",
            role: "",
            dept: "",
            token: "",
            loginToken: "",
            logined: false,
            isBigCustomer: false,
            authorizationCode:'',
            obsKey:'',
            dialogTip: false,
            loginDialog: false,
            forceChangePwd: false
        },

        changePassword: false,
        persistent: false,//是否强制改密码
        account: null,

        servicePath: {
            googleImageUrl: "https://mt1.google.cn/vt/lyrs=s&hl=zh-CN&x={x}&y={y}&z={z}&s=Gali863",
            // 使用manage域名的，双博在天地图中将token添加到白名单中了
            // tdtVecUrl: "https://manage.charmingglobe.com/tdttile?T=vec_w&X={x}&Y={y}&L={z}&tk=d6efc6360972ee1f12cdc863ee28cc9c",
            // tdtVecBzUrl: "https://manage.charmingglobe.com/tdttile?T=cva_w&X={x}&Y={y}&L={z}&tk=d6efc6360972ee1f12cdc863ee28cc9c",
            // tdtImgUrl: "https://manage.charmingglobe.com/tdttile?T=img_w&X={x}&Y={y}&L={z}&tk=d6efc6360972ee1f12cdc863ee28cc9c",
            // tdtImgBzUrl: "https://manage.charmingglobe.com/tdttile?T=cia_w&X={x}&Y={y}&L={z}&tk=d6efc6360972ee1f12cdc863ee28cc9c",
            // 在新pan没有正式转入pan.charmingglobe.com之前，只能用下面的
            tdtVecUrl: 'https://t{s}.tianditu.gov.cn/DataServer?T=vec_w&X={x}&Y={y}&L={z}&tk=07081aad416619ee375499be28d0502c',
            tdtVecBzUrl: 'https://t{s}.tianditu.gov.cn/DataServer?T=cva_w&X={x}&Y={y}&L={z}&tk=07081aad416619ee375499be28d0502c',
            tdtImgUrl: 'https://t{s}.tianditu.gov.cn/DataServer?T=img_w&X={x}&Y={y}&L={z}&tk=07081aad416619ee375499be28d0502c',
            tdtImgBzUrl: 'https://t{s}.tianditu.gov.cn/DataServer?T=cia_w&X={x}&Y={y}&L={z}&tk=07081aad416619ee375499be28d0502c',
            googleUrl: "https://{s}.google.com/hk/x={x}&y={y}&z={z}&s=Galileo863",
            geoServerPath :"http://202.111.178.10:34780/geoserver/gwc/service/wmts?tilematrix=EPSG:900913:{z}&tilerow={y}&tilecol={x}&tilematrixset=EPSG:900913&format=image/png&service=WMTS&version=1.0.0&request=GetTile&layer=",
        },
        wheelPos: undefined,
        compassAngleNum: 0,  // 指北针角度
        level: 2,
        isMeasuring: false,  // 右下角控制键中测量与否的开关
        // 以下是跟侧边栏有关的
        isGallery: 1,
        myLabFucChecked: 0,   // 我的影视库功能选择
        compare: {
            compareShowMode: "",   // "==="不显示对比模式，"screen"分屏, "roller"卷帘
            screenList: [          //分屏区域列表, {, 控制CSS, , , }
                {title: '0', isActive: false, isLeafletOff: true, curDataTitle: '', curLayer: ''},
                {title: '1', isActive: false, isLeafletOff: true, curDataTitle: '', curLayer: ''}
            ],
            isVertical: false,     // 上下卷帘时为true
            rollerList: [         // 卷帘区域列表, isLeafletOff控制图层名字
                { title: 0, isActive: false, isLeafletOff: true, curDataTitle: '', isShow: true },
                { title: 1, isActive: false, isLeafletOff: true, curDataTitle: '', isShow: true }
            ],
            mapContent: {
                maps: { "topLeft": {}, "topRight": {}, "bottomLeft": {}, "bottomRight": {} },
                layerGroup: {},
                baseMap: undefined,  // 卷帘模式下，存储该页面的map实例
            },
            zIndex: -1,   // 设置卷帘初始化地图的深度
            dropData: {}
        },
        // 数据列表内容
        detailTop: "58px",
        demandTabFunc: 0,
        showDetail: false,     // 点击显示订单交付信息
        recordOrderType: 0,    // 订单类型
        record: {},            // 单项订单信息
        isTile: false,         // 是否有切片信息
        hasOrderDetail: false,
        // 影像库内容
        noneDelivery: false,
        showPanel: false,
        showDeliveryDetail: false,
        deliveryDetail: { "id": "" },
        sortByField: "time", sortDire: "desc",  // 排序值，同时在sidebar.vue的“影像库”列表和“数据整理”页面中使用
        // 复制文件以及下载
        showCopyFile: false,
        fileLink: [],
        item: {},
        isFolder: false,
        fileName: "",
        fileNum: 0,
        fileSize: 0,
        showOriginImage: false,
        bifProductId: "",
        isDownloadUrl: false,
        // 显示地图
        mapShowDialog: false,
        geo: { type: "Point", coordinates: [125.6, 10.1] },  // 详情中唤起的地图
        bounds: {},
        showClipMap: false,
        // 文件整理
        sidebarTargetItem: "",
        sidebarTargetId: "",
    },
    getters: {
        getPhotoEndDate: state => state.photoEndDate,
        getDeliveryDetail: state => state.deliveryDetail,
        getCompareShowMode: state => state.compare.compareShowMode,
        getDemandTabFunc: state => state.demandTabFunc,
    }
});
